<template>
  <div class="SubscriptionAddonList">
    <div class="SubscriptionAddonList-header">
      <span class="SubscriptionAddonList-title">{{ t('ui.subscription.details.addons.title') }}:</span>
    </div>

    <ul class="SubscriptionAddonList-list">
      <li
        v-for="addon of addons"
        :key="addon.code"
        class="SubscriptionAddonList-item"
      >
        <!-- TODO: CVO-18429 add support to display addon quantity when available -->
        (1x) {{ t(`custom.addons.${addon.code}.title`) }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@cvo/i18n/composables/useI18n';
import type { SubscriptionAddonListProps } from './SubscriptionAddonList.model';

defineProps<SubscriptionAddonListProps>();

const { t } = useI18n();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .SubscriptionAddonList {
    &-title {
      @include text.text('md', vars.$typography-weight-strong);
    }

    &-item {
      @include text.text('md');
      color: vars.$molecules-breakdown-secondary-text-color;
    }
  }
}
</style>
